import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "FuncionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "FuncionPage",
            ss: ss,
            ajax: {
                "url": ss.indexFuncion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Funcion', name: 'Funcion', title: 'Funcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            funcions: [],
            funcion: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newFuncion() {
            this.funcion = {};
            this.$refs['frm-funcion'].show();
        },
        showFuncion(id) {
            this.isLoading=true;
            this.ss.showFuncion(id).then(
                (result) => {
                    let response = result.data;
                    this.funcion = response.data;
                    this.$refs['view-funcion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editFuncion() {
            this.$refs['frm-funcion'].show();
            this.$refs['view-funcion'].hide();
        },
        cancelFuncion() {
            if (this.funcion.id) {
                this.$refs['view-funcion'].show();
            }
            this.$refs['frm-funcion'].hide();
        },
        saveFuncion() {
            this.ss.storeFuncion(this.funcion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);

                    this.$refs['frm-funcion'].hide();
                    this.$refs['datatable-funcion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteFuncion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyFuncion(this.funcion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-funcion'].hide();
                                this.$refs['datatable-funcion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Funcion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showFuncion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
          this.$router.push('/Login');
        }
    }
};
